/**
 * HTTP request methods to indicate the desired action
 * to be performed for a given resource.
 */
const METHODS = {
  fromUrl: /GET|HEAD/i,
  hasBody: /POST|OPTIONS|PUT|PATCH|DELETE/i,
};

export default METHODS;
